"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _sidePaneActions = require("../../redux/actions/sidePaneActions");
var _FiatNavItemsComponent = _interopRequireDefault(require("./FiatNavItemsComponent"));
var _selectors = require("../../redux/margin/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var accounts = (0, _selectors.notMarginAccountsSelector)(state);
  return {
    hasAccounts: accounts && accounts.length > 0
  };
};
var mapDispatchToProps = {
  openRetailFiatSidePane: _sidePaneActions.openRetailFiatSidePane
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FiatNavItemsComponent["default"]);